import {
  getProcessDetailRoute,
  getTaskRoute
} from "@certa/common/utils/routes";
import type { ModelledAPIResponse } from "@certa/queries/types/globalSearch.types";
import { useNavigate } from "react-router";
import { useNavigationDrawer } from "../../NavigationSidebar";
import { useSearchStore } from "../store/useSearchStore";
import type { SearchItem } from "../GlobalSearchNext.schema";
import { transformSearchResult } from "../utils/searchTransformers";
import { useCallback } from "react";

type UseSearchNavigationProps = {
  setRecentSearches: (item: SearchItem) => void;
};

export const useSearchNavigation = ({
  setRecentSearches
}: UseSearchNavigationProps) => {
  const navigate = useNavigate();
  const { setIsSearchModalOpen } = useNavigationDrawer();
  const { resetSearch } = useSearchStore();

  const onSelectSearchResult = useCallback(
    (result: ModelledAPIResponse.SearchResult) => {
      if (!result) return;
      const transformedResult = transformSearchResult(result);

      if (result.type === "workflow") {
        navigate(getProcessDetailRoute(result.id));
      } else if (result.type === "file") {
        navigate(
          getTaskRoute({
            processId: result.workflow.id,
            taskId: result.step.id
          })
        );
      }
      if (transformedResult) {
        setRecentSearches(transformedResult);
      }
      setIsSearchModalOpen(false);
      resetSearch();
    },
    [navigate, setRecentSearches, setIsSearchModalOpen, resetSearch]
  );

  const onSelectRecentSearch = useCallback(
    (item: SearchItem) => {
      if (item.type === "workflow") {
        navigate(getProcessDetailRoute(item.id));
      } else if (item.type === "file") {
        navigate(
          getTaskRoute({
            processId: item.workflowId,
            taskId: item.stepId
          })
        );
      }
      setRecentSearches(item);
      setIsSearchModalOpen(false);
      resetSearch();
    },
    [navigate, setRecentSearches, setIsSearchModalOpen, resetSearch]
  );

  return { onSelectSearchResult, onSelectRecentSearch };
};
